import request from "@/utils/request";

/**
 * 获取车型列表。
 * @param {Object} data 请求参数，可传入 car_category 车型能源分类。
 */
export function postCarList(data = {}) {
    return request({
        url: "/api/v1/6a85271b8f581",
        method: "post",
        data,
    });
}

/**获取技术分类*/
export function postTechnologyCategory(data) {
    return request({
        url: "/api/v1/6a83da0828ba9",
        method: "post",
        data,
    });
}
